<template>
  <BaseContainer class="mt-14 md:mt-10 md:mb-16 px-0 md:px-5">
    <div
      class="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10 md:gap-y-0 py-6 md:py-10 bg-gray-10 px-[20px] md:px-16 min-[1330px]:-mx-16 md:rounded-3xl"
    >
      <NuxtLinkLocale
        v-for="(item, index) in data"
        :key="index"
        class="w-full hover:opacity-50"
        :to="item.url"
      >
        <div class="relative w-full h-[218px] md:h-auto md:pt-[100%]">
          <div
            class="absolute top-0 left-0 w-full h-full bg-primary-white rounded-xl"
          >
            <img
              :alt="item.title"
              :src="item.imageUrl"
              class="w-full h-full object-cover rounded-xl"
            />
            <div
              :class="
                twJoin(
                  'absolute bottom-0 right-0 z-10 pt-2 md:pt-3 pl-2 md:pl-3 bg-gray-10 rounded-tl-xl',
                  `after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-3 after:h-3 after:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_#F2F2F3_12px)] after:rotate-180 after:-translate-x-[100%]`,
                  `before:content-[''] before:absolute before:right-0 before:top-0 before:w-3 before:h-3 before:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_#F2F2F3_12px)] before:rotate-180 before:-translate-y-[100%]`
                )
              "
            >
              <div
                class="w-10 h-10 md:w-16 md:h-16 bg-black flex items-center justify-center rounded-xl"
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.5 2.01562V19.5156C25.5 20.2188 24.875 20.7656 24.25 20.7656C23.5469 20.7656 23 20.2188 23 19.5156V5.0625L2.60938 25.4531C2.375 25.6875 2.0625 25.7656 1.75 25.7656C1.35938 25.7656 1.04688 25.6875 0.8125 25.4531C0.34375 24.9844 0.34375 24.125 0.8125 23.6562L21.2031 3.26562H6.67188C6.04688 3.26562 5.42188 2.64062 5.5 2.01562C5.5 1.3125 6.04688 0.765625 6.75 0.765625H24.25C24.875 0.765625 25.5 1.39062 25.5 2.01562Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-10 relative z-10 pt-4 space-y-2">
          <div class="text-xl font-bold text-center">{{ $t(item.title) }}</div>
        </div>
      </NuxtLinkLocale>
    </div></BaseContainer
  >
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'

const data = [
  {
    title: 'products.strap',
    imageUrl: '/images/Cable-picture_Wrist-Lanyard.png',
    url: '/products/strap'
  },
  {
    title: 'products.airpods',
    imageUrl: '/images/CaseAirpods-clear.png',
    url: '/products/airpods'
  },

  {
    title: 'products.magsafe',
    imageUrl: '/images/walletset.png',
    url: '/products/magnetic-wallet'
  },
  {
    title: 'products.griptok',

    imageUrl: '/images/navigation/griptok2084x2084.png',
    url: '/products/clear-popgrip'
  }
]
</script>
